export default __webpack_public_path__ + "static/media/icon-cadastro-cliente.2c0b7ae4.svg";